(function () {
  const initMegaSubmenu = (header) => {
    const megaSubmenuLinks = header.querySelectorAll(".list-menu--megasubmenu");
    if (!megaSubmenuLinks || !megaSubmenuLinks.length) return;
    megaSubmenuLinks.forEach((link) => {
      const tabs = link.querySelectorAll(".mega-submenu__tab");
      const submenus = link.querySelectorAll(".mega-submenu__submenu");
      const onToggle = (event) => {
        const tab = event.target;
        if (!tab || !tab.classList.contains("mega-submenu__tab")) return;
        const tabId = tab.dataset.tabId;
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");
        submenus.forEach((submenu) => {
          submenu.classList.remove("active");
          if (submenu.dataset.tabId === tabId) {
            submenu.classList.add("active");
          }
        });
      };
      tabs.forEach((tab) => {
        tab.addEventListener("click", onToggle);
        tab.addEventListener("mouseenter", onToggle);
      });
    });
  };

  const header = () => {
    const header = document.querySelector(".shopify-section-header");

    $("[data-hover-opacity]").hover(
      function () {
        if (
          $(this).hasClass("header__follow") &&
          $(".header-details__search").attr("open")
        ) {
          return "";
        }
        const id = $(this).data("hover-opacity");
        $(`[data-hover-opacity=${id}]`).addClass("opacity");
        $(this).removeClass("opacity");
      },
      function () {
        const id = $(this).data("hover-opacity");
        $(`[data-hover-opacity=${id}]`).removeClass("opacity");
      }
    );

    const headerOverlay = document.querySelector(".header__overlay");
    const searchDetails = document.querySelector(".header__search details");
    headerOverlay.addEventListener("click", () => {
      searchDetails.removeAttribute("open");
      document.body.classList.remove("overflow-hidden-search");
    });

    initMegaSubmenu(header);
  };

  document.addEventListener("shopify:section:load", header);

  header();
})();
